import { render, staticRenderFns } from "./customReports.vue?vue&type=template&id=621b074b&scoped=true&"
import script from "./customReports.vue?vue&type=script&lang=js&"
export * from "./customReports.vue?vue&type=script&lang=js&"
import style0 from "./customReports.vue?vue&type=style&index=0&id=621b074b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b074b",
  null
  
)

export default component.exports